/**
 *  APP王子。。。给APP一个吻唤醒它吧。。。。
 *  活动专用
 */

export default {
  /**
   * @desc 下载 APP
   * @param info
   * {
   *   schemaUrl-唤醒url,
   *   tencentUrl-应用宝url,
   *   itunesUrl-itunes下载地址,
   *   androidDlUrl-安卓下载包地址
   * }
   */
  kiss(info) {
    if (!this.uaInfo) {
      this.uaInfo = this.getUA()
    }
    let schemaHead = info.schemaUrl

    // iOS  活动没有通用链接 直接唤醒，唤醒不成功跳itunes
    if (this.uaInfo.isIOS) {
      if (this.uaInfo.isWeixin || this.uaInfo.isQQ || this.uaInfo.isQQBrowser) {
        window.location.href =
          info.tencentUrl + '&ios_schema=' + encodeURIComponent(info.schemaUrl)
        return
      }
      this.schemaKiss([schemaHead], false)
      setTimeout(() => {
        this.appStoreKiss(info)
      }, 800)
      // }
    } else {
      // QQ和微信跳应用宝 非微信直接唤醒，唤醒不成功再下载
      if (this.uaInfo.isWeixin) {
        window.location.href =
          info.tencentUrl +
          '&android_schema=' +
          encodeURIComponent(info.schemaUrl)
        return
      }

      this.schemaKiss([schemaHead])
    }
  },

  /**
   * 来个schema之吻吧
   * @param {Array} schema schema列表
   * @param {Object} info 播放场景信息
   * @param {Boolean} openType 触发方式：
   * `true` 自动判断，一般默认iframe 触发
   * `false` location.href 触发
   */
  schemaKiss(schema, openType = true) {
    // if(this.isHidden()){
    //     return;
    // }
    for (var i = 0, len = schema.length; i < len; i++) {
      let schemaurl = schema[i]
      setTimeout(() => {
        if (!openType || (this.getUA().isAndroid && this.getUA().isChrome)) {
          window.location.href = schemaurl
          return
        }
        this.openByIframe(schemaurl)
        return
      }, 200 * i)
    }
  },

  /**
   * 去到apple store 唤醒或下载
   * @param {Object} info 播放场景信息
   */
  appStoreKiss(info) {
    // if (this.isHidden()) {
    //     return;
    // }

    location.href = info.itunesUrl
  },

  /**
   * 来个通用链接之吻吧
   *
   */
  universalLinksKiss() {
    let link =
      'https://msite.api.mgtv.com/act-download.html?type=act&code=c103801&from=hitv&url=' +
      encodeURIComponent('https://app.mgtv.com/credits/index.html')
    // 新版数据上报
    window.location.href = link
  },

  /**
   * 下载app
   * @param  {Object} info 播放场景信息
   */
  download(info) {
    // if (this.isHidden()) {
    //     return;
    // }
    if (this.getUA().isIOS) {
      this.appStoreKiss(info)
    } else {
      //安卓&&微信跳转到应用宝
      if (this.getUA().isAndroid && this.getUA().isWeixin) {
        // 微信&安卓，通过分享链接过来的，跳转不同的应用宝下载页
        window.location.href =
          info.tencentUrl +
          '&android_schema=' +
          encodeURIComponent(info.schemaUrl)
        return
      }

      window.location.href = info.androidDlUrl
    }
  },

  /**
   * 通过iframe触发地址
   * @param  {String} link 打开地址
   */
  openByIframe(link) {
    let iframe = document.getElementById('open_app_iframe')
    if (!iframe) {
      iframe = document.createElement('iframe')
      iframe.setAttribute('id', 'open_app_iframe')
      iframe.setAttribute('width', '0px')
      iframe.setAttribute('height', '0px')
      iframe.style.display = 'none'

      document.body.appendChild(iframe)
    }

    iframe.setAttribute('src', link)
  },

  /**
   * @desc 获取 UA
   */
  getUA() {
    let ua = navigator.userAgent.toLowerCase()

    let mobileSafari =
      /iPhone|iPad|iPod/i.test(ua) &&
      /iPhone|iPod|iPad/i.test(navigator.platform) &&
      /Safari\/[\d\.]+$/i.test(ua)

    let iosVersion = 0
    var p = /iphone os ([0-9]+)_/i
    var matchResult = ua.match(p)
    if (matchResult && matchResult.length > 1) {
      iosVersion = parseInt(matchResult[1], 10)
    }

    let isPad = /iPad/i.test(ua)

    let result = {
      isPad: isPad,
      isSafari: mobileSafari,
      isIqiyi: /iqiyi/.test(ua),
      isBaidu: /baidu/.test(ua),
      isUCBrowser: /ucbrowser/.test(ua),
      isQQBrowser: /qqbrowser/.test(ua),
      isQQLiveBrowser: /qqlivebrowser/.test(ua),
      isQQ:
        / QQ/.test(navigator.userAgent) ||
        (/MQQBrowser/.test(navigator.userAgent) &&
          /QQ/.test(navigator.userAgent.split('MQQBrowser'))),
      isWeixin: /micromessenger/.test(ua) || /weixin/.test(ua),
      isAndroid: /android/.test(ua),
      isIOS:
        /iphone/.test(ua) ||
        /ipad/.test(ua) ||
        /itouch/.test(ua) ||
        /ipod/.test(ua),
      isFirefox: /firefox/.test(ua),
      isImgotv: /imgo/.test(ua),
      isBaiduBrowser: /baidubrowser/.test(ua),
      isChrome: /chrome/.test(ua),
      iosVersion: iosVersion,
    }

    this.getUA = function () {
      return result
    }

    return result
  },
}
